
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  const quickLinks = [
    { name: t('About Us'), href: '#about' },
    { name: t('Courses'), href: '#courses' },
    { name: t('Pricing'), href: '#pricing' },
    { name: t('Blog'), href: '#blog' }
  ];
  
  const support = [
    { name: t('FAQ'), href: '#faq' },
    { name: t('Help Center'), href: '#help' },
    { name: t('Contact'), href: 'https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr' }
  ];
  
  const legal = [
    { name: t('Privacy Policy'), href: '#privacy' },
    { name: t('Terms of Service'), href: '#terms' }
  ];
  
  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', name: 'Facebook' },
    { icon: 'ri-twitter-x-fill', href: '#', name: 'Twitter' },
    { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr', name: 'Instagram' },
    { icon: 'ri-youtube-fill', href: '#', name: 'YouTube' }
  ];
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-riding-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                {t('Action English')}
              </h3>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('Learn English through the exciting world of action sports')}
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">{t('Quick Links')}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-lg font-semibold mb-6">{t('Support')}</h4>
            <ul className="space-y-3">
              {support.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-6">{t('Legal')}</h4>
            <ul className="space-y-3">
              {legal.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            {t('© 2024 Action English. All rights reserved.')}
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
